import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import Symbols from '../../../common/assets/symbols'

const Billboard = (props) => {
  const {
    title,
  } = props

  if (!title) {
    return null
  }

  return (
    <div className="billboard">
      <div className="billboard__background">
        <div className="billboard__image" style={{ backgroundImage: `url("${title.artwork.feature}")`, }} />
        <div className="billboard__gradient-overlay" />
      </div>
      <div className="billboard__content">
        <div className="billboard__content-item">
          <h3 className="billboard__title">{title.name}</h3>
          <div className="billboard__overview">
            <div className="billboard__specs">
              <span className="billboard__spec-item">{title.releaseDate}</span>
              <span className="billboard__spec-item">{`${title.runtime} minutes`}</span>
            </div>
            <div className="billboard__logline">{title.logline}</div>
          </div>
          <Link className="billboard__play-button" to={`/watch/${title.id}`}>
            <span>
              <span className="billboard__play-button-icon">{Symbols.play}</span>
            </span>
            <span className="billboard__play-button-text">Play</span>
          </Link>
        </div>
      </div>
    </div>
  )
}

Billboard.propTypes = {
  title: PropTypes.object,
}

export default Billboard



// WEBPACK FOOTER //
// ./src/desktop/components/billboard/index.js